<template>
  <div class="dataBaseContent_wrapper" :style="wraperStyle">
    <div class="content_nav-wrapper">
      <div class="content_nav-wrapper-content">
        <span
        @click="activeIndex = 0"
        class="content_nav"
        :class="{ 'content_nav-active': activeIndex == 0 }"
        >功率曲线</span>
        
      <span
        @click="activeIndex = 1"
        class="content_nav"
        :class="{ 'content_nav-active': activeIndex == 1 }"
        >机型参数</span
      >
      </div>
      
    </div>
    <div
      class="content"
      v-if="isExitTurbine || isCompare"
      :style="contentStyle"
    >
      <!-- 对比功率曲线类型切换 -->
      <div class="select-curve" v-if="showTop">
        <el-radio-group v-model="compareSelectType">
          <el-radio-button label="功率曲线"></el-radio-button>
          <el-radio-button label="推力系数"></el-radio-button>
        </el-radio-group>
      </div>
      <powerCurve
        v-if="activeIndex == 0"
        :comparePowerCurveType="comparePowerCurveType"
        :activeIndex="activeIndex"
      ></powerCurve>
      <techParameters
        v-if="activeIndex == 1"
        @tableHeight="tableHeight"
      ></techParameters>
    </div>
    <!-- 无机型库时展示无数据 -->
    <div class="empty" v-if="!isExitTurbine && !isCompare">
      <div class="empty-text">暂无数据</div>
    </div>
    <div class="upload">
      <upload></upload>
    </div>
  </div>
</template>

<script>
import powerCurve from './power-curve';
import techParameters from './tech-parameters';
import upload from './uploader';
import { mapState } from 'vuex';
export default {
  components: {
    powerCurve,
    techParameters,
    upload
  },
  data() {
    return {
      activeIndex: 0,
      compareSelectType: '功率曲线',
      contentStyle: {
        padding: '20px'
      },
      wraperStyle: {
     
      }
    };
  },
  computed: {
    ...mapState('model', ['isCompare', 'currentTurbine', 'turType']),
    comparePowerCurveType() {
      if (this.compareSelectType === '功率曲线') {
        return 3;
      } else {
        return 4;
      }
    },
    isExitTurbine() {
      if (Object.keys(this.currentTurbine).length > 0) {
        return true;
      } else {
        return false;
      }
    },
    showTop() {
      if (this.activeIndex == 0 && this.isCompare) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    // isCompare(val) {
    //   if (val && this.activeIndex === 0) {
    //     this.contentStyle = {
    //       padding: '70px 10px 20px 10px'
    //     };
    //   } else {
    //     this.$nextTick(() => {
    //       this.contentStyle = {
    //         padding: '20px'
    //       };
    //     });
    //   }
    // },
    // activeIndex(val) {
    //   if (val == 1) {
    //     this.contentStyle = {
    //       padding: '20px'
    //     };
    //     this.wraperStyle = {
    //       height: 'calc(100% - 52px)'
    //     };
    //   } else {
    //     if (Object.keys(this.currentTurbine).length > 0) {
    //       this.wraperStyle = {
    //         height: 'auto'
    //       };
    //     } else {
    //       // 非对比无数据的时候展示
    //       this.wraperStyle = {
    //         height: 'calc(100% - 52px)'
    //       };
    //     }
    //     if (this.isCompare) {
    //       this.contentStyle = {
    //         padding: '70px 10px 20px 10px'
    //       };
    //     }
    //   }
    // },
    // turType(val) {
    //   if (val == '0') {
    //     if (Object.keys(this.currentTurbine).length > 0) {
    //       this.wraperStyle = {
    //         height: 'auto'
    //       };
    //     } else {
    //       // 非对比无数据的时候展示
    //       this.wraperStyle = {
    //         height: 'calc(100% - 52px)'
    //       };
    //     }
    //   } else {
    //     this.wraperStyle = {
    //       height: 'calc(100% - 52px)'
    //     };
    //   }
    // }
  },
  methods: {
    tableHeight(val) {
      console.log(val);
    },
    handleClick() {}
  }
};
</script>

<style lang="less" scoped>

.dataBaseContent_wrapper {
  overflow: auto;
  position: relative;
  height: 100%;
  .empty {
    min-height: calc(100% - 30px);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    font-size: 14px;
    height: 100%;
  }
  .upload {
    position: absolute;
    right: 54px;
    top: 8px;
    width: 100px;
    height: 35px;
    line-height: 34px;
    cursor: pointer;
    background-color: #1890ff;
    color: #fff;
    border-radius: 4px;
  }
  /deep/.edit-database {
    right: 20px;
  }
  
  /deep/.dialog-container .btn span[data-v-188a1426] {
    line-height: 28px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #547efc;
  }
  /deep/.el-icon-upload2{
    content: url("../../../asset/wind-data/data-upload.png");
    width: 16px;
    height: 13px;
    position: relative;
    top: 2px;
  }
}
.content_nav:before {
  height: 0 !important;
}
</style>

